import axiosClient from './axiosClient';

export const getCountry = (): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/countries`;
    return axiosClient.get(url);
};
